export const UserRegistrationInfoTableConfig = [
  {
    title: "User ID",
    dataIndex: "user.id"
  },
  {
    title: "이메일",
    dataIndex: "user.email"
  },
  {
    title: "이름",
    dataIndex: "user.name"
  },
  {
    title: "기업",
    dataIndex: "organization.name"
  }
];
